import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Grid, TextField } from "@mui/material";
import { alertService, setBackdrop } from "common-frontend-components";
import { createImageProcessingAwaiter, PhotoUploader } from "../posts/Photos/PhotoUploader";
import { textColor } from "../../../assets/styles/colors";
import { postCardStyle, textFieldStyle } from "../../../assets/styles/styles";
import { JsonInput } from "./JSONEditorReact";
import { sitePhotoStore } from "../../../stores/appConfig/sitePhotoStore";
import { SelectGroup } from "./SelectGroup";
import { callCreateSitePhotoAsync, callCreateSitePhotoGroupAsync, callGetSitePhotoByKeyAsync, callInitSitePhotoUploadAsync } from "../../../apis/sitePhotos";
import { sitePhotoGroupStore } from "../../../stores/appConfig/sitePhotoGroupStore";
export const handleOnDropWhenFormingNewSitePhoto = (files) => {
    sitePhotoStore.setNewSitePhoto({ ...sitePhotoStore.getNewSitePhoto(), files });
};
const createSitePhoto = async ({ path, params }) => {
    const sitePhoto = await callCreateSitePhotoAsync({ path, params });
    sitePhotoStore.setData([sitePhoto, ...sitePhotoStore.getData()]);
    return sitePhoto;
};
const createSitePhotoGroups = async ({ groups }, sitePhotoId) => {
    const sitePhotoGroups = [];
    for (const i of groups) {
        try {
            sitePhotoGroups.push(await callCreateSitePhotoGroupAsync({ sitePhotoId, group: i }));
        }
        catch (e) {
            alertService.error(e);
        }
        finally {
            sitePhotoGroupStore.setData([...sitePhotoGroups, ...sitePhotoGroupStore.getData()]);
        }
    }
};
export const createSitePhotoImages = async (items) => {
    for (const i of items) {
        console.log('starting upload', { PostImageItem: i });
        const uploadTime = new Date();
        const res = await callInitSitePhotoUploadAsync(i.file, { contentType: i.file.type, path: i.path, CacheControl: i.CacheControl });
        console.log('upload complete!', { res });
        const imageProcessingAwaiter = createImageProcessingAwaiter(() => callGetSitePhotoByKeyAsync(res.key).then(r => {
            if (!r.photoLastModified)
                return null;
            if (r.photoLastModified?.getTime() < uploadTime.getTime())
                return null;
            return r;
        }));
        const sitePhoto = await imageProcessingAwaiter();
        if (sitePhoto !== null) {
            sitePhotoStore.setData([sitePhoto, ...sitePhotoStore.getData().filter(ii => ii.id !== sitePhoto.id)]);
        }
    }
};
export const onCreatePost = async () => {
    const newItem = sitePhotoStore.getNewSitePhoto();
    setBackdrop(true);
    try {
        const item = await createSitePhoto(newItem);
        await createSitePhotoGroups(newItem, item.id);
        await createSitePhotoImages(newItem.files.map((file) => ({ file, path: newItem.path, CacheControl: newItem.params?.CacheControl })));
        sitePhotoStore.clearSitePhoto();
    }
    catch (e) {
        alertService.error(e);
    }
    finally {
        setBackdrop(false);
    }
};
export const CreateSitePhoto = () => {
    return (_jsx(Box, { sx: { minWidth: 275 }, children: _jsxs(Card, { variant: "outlined", elevation: 3, sx: postCardStyle, children: [_jsxs(CardContent, { children: [_jsx(Typography, { sx: { fontSize: 16, paddingBottom: 2, color: textColor }, color: "text.secondary", gutterBottom: true, children: "New Site Photo" }, void 0), _jsxs(Grid, { container: true, spacing: 2, children: [_jsx(Grid, { item: true, children: _jsx(TextField, { sx: textFieldStyle, label: "Unique ID", variant: "outlined", value: sitePhotoStore.useNewSitePhotoPath(), onChange: sitePhotoStore.handleNewSitePhotoPathChange, placeholder: 'home/header/1' }, void 0) }, void 0), _jsxs(Grid, { item: true, xs: 12, children: [_jsx(Typography, { sx: { fontSize: '1rem', paddingBottom: 0, color: textColor }, color: "text.secondary", gutterBottom: true, children: "Custom Parameters" }, void 0), _jsx(JsonInput, { boxProps: { sx: { width: '100%', height: 300 } }, onChange: sitePhotoStore.onParamsChange, value: sitePhotoStore.useNewSitePhotoParams() }, void 0)] }, void 0), _jsx(Grid, { item: true, xs: 12, children: _jsx(PhotoUploader, { dropzoneOptions: { maxFiles: 1 }, onDrop: handleOnDropWhenFormingNewSitePhoto, usePreviewFiles: sitePhotoStore.useNewSitePhotoFile, setPreviewFiles: sitePhotoStore.setNewSitePhotoFiles }, void 0) }, void 0), _jsx(Grid, { item: true, xs: 12, children: _jsx(SelectGroup, {}, void 0) }, void 0)] }, void 0)] }, void 0), _jsx(CardActions, { children: _jsx("div", { style: { paddingLeft: 4, paddingRight: 4 }, children: _jsx(Button, { size: "small", onClick: onCreatePost, children: "Create Site Photo" }, void 0) }, void 0) }, void 0)] }, void 0) }, void 0));
};
//# sourceMappingURL=CreateSitePhoto.js.map